/*******************************************************************************
 * Copyright (c) 2019-2021 Singularity AI, Inc. - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 ******************************************************************************/
/* import */
import { gql } from 'graphql-tag';
/* AppSync */
import appsyncclient from '../../api/AppSync';
/* GraphQL */
import {
  PROFILE_ID,
  queryGetProfile,
  mutationUpdateProfile
} from '../../graphql/SettingsProfile';
import Message from '../../qg-components/src/libs/Message/index';
const initialState = {
  getProfile: {
    FirstName: "",
    LastName: "",
    Email: "",
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    Zipcode: ""
  }
};
/*******************************************************************************
 * main
 ******************************************************************************/
export function settingsProfileReducer(state = initialState, action) {
  switch (action.type) {

    case 'settings/ProfileLoaded': return action.payload;

    default:
      return state;
  };
};

// Thunk function
// get profile
export async function fetchGetProfile(dispatch, getState) {
  try {
    const response = await appsyncclient.query({
      query: gql(queryGetProfile),
      variables: { profile_id: PROFILE_ID },
      fetchPolicy: 'no-cache',
    });
    dispatch({ type: 'settings/ProfileLoaded', payload: response.data });
  } catch (error) {
    console.log('fetchGetProfile error: ', error);
  };
};

// update profile
export function fetchUpdateProfile(params) {
  return async dispatch => {
    try {
      // console.log(dispatch, params)
      const response = await appsyncclient.mutate({
        mutation: gql(mutationUpdateProfile),
        // mutation: queryAddGeneralList
        variables: { profile_id: PROFILE_ID, ...params }
      });
      console.log(response)
      Message.success('保存成功')
    } catch (error) {
      console.log('fetchUpdateProfile error: ', error);
    };
  };
};